import GetRoles from '@/graphql/Users/GetRoles.gql'
import GetRole from '@/graphql/Users/GetRole.gql'
import AddRole from '@/graphql/Users/AddRole.gql'
import SaveRoleSessionConfig from '@/graphql/Users/SaveRoleSessionConfig.gql'
import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getRole ({ commit, dispatch }, { roleId }) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetRole,
        variables: {
          roleId
        },
        fetchPolicy: 'no-cache'
      })
      return data.Role
    } catch (error) {
      dispatch('showError', error)
    }
  },

  async getRoles ({ commit, dispatch }, { pageNumber, perPage }) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetRoles,
        variables: {
          pageNumber: pageNumber,
          perPage: perPage
        }
      })
      return data.Roles
    } catch (error) {
      dispatch('showError', error)
    }
  },

  async saveCustomRole ({ commit, dispatch }, { roleName, roleBase }) {
    try {
      const { data } = await apollo.defaultClient.mutate({
        mutation: AddRole,
        variables: {
          roleName,
          roleBase
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'El rol se ha creado correctamente' })
      return data.saveCustomRole
    } catch (error) {
      dispatch('showError', error)
    }
  },

  async saveRoleSessionConfig ({ commit, dispatch }, { roleId, roleSessionConfig }) {
    try {
      const inactivityTimeMinutes = roleSessionConfig?.inactivityTimeMinutes
      const safeRoleSessionConfig = {
        inactivityTimeMinutes: inactivityTimeMinutes === '' || inactivityTimeMinutes == null
          ? null
          : Number(inactivityTimeMinutes),
        singleSession: !!roleSessionConfig?.singleSession
      }
      const { data } = await apollo.defaultClient.mutate({
        mutation: SaveRoleSessionConfig,
        variables: {
          roleId,
          roleSessionConfig: safeRoleSessionConfig
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'La configuración de sesión se ha guardado correctamente' })
      return data.saveRoleSessionConfig
    } catch (error) {
      dispatch('showError', error)
    }
  }
}
